import { Generator } from '@visactor/vrender-core';

export const GIFIMAGE_NUMBER_TYPE = Generator.GenAutoIncrementId();
export const LOTTIE_NUMBER_TYPE = Generator.GenAutoIncrementId();
